import * as React from 'react';
import { Graft, TargetDetails, Conduit, IndicatorState, Tabs } from "./TriggerClasses";
import ConduitVisualize from './ConduitVisualize';
import { VascularGraft,AVAccessType } from './VascularClasses';
import { MeasurmentThumbnail } from '../../Components/MeasurementThumbnail';
import { PreviewProcedureModel } from '../PreviewProcedureModel';
import { DataHelper } from '../../Helpers/DataHelper';
import { StudyModel } from '../StudyModel';
import { PreviewMeasurement } from '../PreviewMeasurement';


class SubwayMap extends React.Component < {
    CurrentItem : Graft,
    Context : string,
    customGraftText : string,
    index: number, 
    commentsOpen: boolean,
    commentToggled: (e: boolean) => void,
    measurementSelectionOpen: boolean,
    measurementSelectionSelected: (e: boolean) => void,
    showsaves: boolean,
    showeditbutton: boolean,
    tileColorOn: boolean,
    parentProcedure: PreviewProcedureModel,
    studySelected: StudyModel, 
    dataHelper: DataHelper,
    showSelected: boolean,
    measurementAllocated?: (timestep:string, procedureId: string, measurementId: string, graftId: string) => void,
    editGraftClicked? : (timestep:string, procedureId: string, graftId: string)=>void
}, {
    frequentUsedOpen: boolean,

},
any > {

    static defaultProps = {
        commentsOpen: false,
        showsaves: false,
        parentProcedure: null,
        studySelected: null,
        dataHelper: null,
        showSelected: true,
        showeditbutton: false,
        measurementAllocated: () => {},
        editGraftClicked: () => {}
      }

    constructor(props : any) {
        super(props);
        this.state = {
            frequentUsedOpen: false
        };
    }

    rowContainer: React.ReactElement[] = [];
    columnContainerAll: React.ReactElement[][] = [];
    columnContainerAllGraftIds: string[] = [];
    indentCount: number = 0;
    indentCountMax: number = 0;
    measuredGraftId: string = "";
 
    manuallyAddAVAccessBottom = ()=>
    {
        let columnContainer = [];
        
        for (let index = 0; index < 2; index++) {

            let showBottom = false;
            if ((this.props.CurrentItem as VascularGraft) && (this.props.CurrentItem as VascularGraft).AVConfig)
            {
            if ((this.props.CurrentItem as VascularGraft).AVConfig && ((this.props.CurrentItem as VascularGraft).AVConfig as AVAccessType).indexOf("ENDA") === 0 && index === 0 )
                {
                    showBottom = true;
                }
                if ((this.props.CurrentItem as VascularGraft).AVConfig && ((this.props.CurrentItem as VascularGraft).AVConfig as AVAccessType).indexOf("ENDV") > 0 && index === 1 )
                {
                    showBottom = true;
                }
            //But indentation should only include ConduitVisualize from the direct parent
                columnContainer.push(<div key={"col"+index} className={"visual-graft-column av-access-item "}>
                    <ConduitVisualize leftConduit={((index === 0 ? null : Conduit.SVG)) as string} rightConduit={((index === 0 ? Conduit.LITA : null)) as string} topConduit={(index === 0 ? Conduit.LITA : Conduit.SVG)} bottomConduit={(showBottom ? (index === 0 ? Conduit.LITA : Conduit.SVG): null) as string}></ConduitVisualize>
                </div>);     
            }  
        }
        this.rowContainer.push(
            <div  key={"row" } className="visual-graft-row">
                {columnContainer}
            </div>);
            // if (columnContainer.length > this.indentCountMax)
            // {
            //     this.indentCountMax = columnContainer.length;
            // }
        this.columnContainerAll.push(columnContainer);
    }

    recurseBuildGraft = (childGraft: Graft, columnContainer: React.ReactElement[], parentIsSource = false, parentConduit: Conduit | undefined, parentIndent: number = 0, yChildren: number = 0, latestYConduit: Conduit | undefined, leftmost: boolean = false ) => {
       
      
       let isTopLevel = childGraft.type === "Source"  || childGraft.type === "Carotid" || childGraft.type === "NewGraft";
       let sequentialChildren = 0;
      
       if (childGraft.targets)
       {
            for (let index = 0; index < childGraft.targets.length; index++) {
                const element = childGraft.targets[index];
                if (element.sequential)
                {
                    sequentialChildren++;
                }else
                {
                    yChildren++;
                    latestYConduit = element.conduit as Conduit;
                }
            }
       }
       let hasBeenSavedClass: string = "";

    //    let savedInstances = this.context.getTTFMSavedInstance(childGraft.Id);
    //    if (this.props.Context === "Imaging")
    //    {
    //     savedInstances = this.context.getImagingSavedInstance(childGraft.Id);
    //    }
        // let savedInstances = this.context.getAllSavedInstances(childGraft.Id);
        // if (savedInstances && savedInstances.length > 0 )
        // {
        //     hasBeenSavedClass = "saved ";
        //     savedItemCount = savedInstances.length;
        // }
        // let beingMeasured = childGraft.Id === this.measuredGraftId;
         let indication: IndicatorState = IndicatorState.none;
        // if (beingMeasured && hasBeenSavedClass)
        //     indication = IndicatorState.measuringsaved;
        // else if (beingMeasured)
        //     indication = IndicatorState.measuring;
        // else if (hasBeenSavedClass)
        //     indication = IndicatorState.saved;

        let buttonText = childGraft.title ? childGraft.title : childGraft.name;
        let isSourceClass = (isTopLevel  ? "is-source " : "");
        if (childGraft.type === "NewGraft")
            isSourceClass = "is-blank-item ";
        if (childGraft.type === "AVVein")
        {
            isSourceClass = "av-access-item ";
        }
        if (childGraft.type === "Source" && TargetDetails.getTargetDetail(childGraft.conduit as Conduit).isSource)
        {
            
            buttonText = buttonText + (childGraft.inSitu ? " In situ" : " Free");
        }
        if (childGraft.type === "Source" && !childGraft.inSitu)
        {
            buttonText = "AORTA";
        }
        if (childGraft.type === "NewGraft")
        {
            buttonText = "Location Undefined";
        }
        
       let itemToAdd =  <><div key={childGraft.id} className={"visual-graft-column " + isSourceClass }>
       <ConduitVisualize 
       leftConduit={(isTopLevel || ((childGraft.type === "AVVein"|| childGraft.type === "AVAccessGraft")) ? null : (childGraft.type === "PeripheralGraft" && leftmost ? Conduit.LITA : parentConduit))as string } 
       rightConduit={(isTopLevel || sequentialChildren===0 || childGraft.type === "AVVein"|| childGraft.type === "AVAccessGraft"? (childGraft.type === "PeripheralGraft" ? Conduit.LITA : null) : parentConduit) as string}
       bottomConduit={(isTopLevel || (yChildren > 0 && parentIndent > 0) || (childGraft.type === "AVVein" || childGraft.type === "AVAccessGraft")  ? parentConduit : null) as string}
       bottomIndicator={(yChildren > 0 && parentIndent > 0) ? 0 : indication}
       leftIndicator={indication}
       topIndicator={indication}
       rightIndicator={sequentialChildren>0 || childGraft.type === "AVVein"|| childGraft.type === "AVAccessGraft"? IndicatorState.none: indication }
       mode={Tabs.TTFM}
       ></ConduitVisualize>
       <button className={"visual-graft-button " +isSourceClass + hasBeenSavedClass +  ((this.props.showSelected && (childGraft.id === this.measuredGraftId  || childGraft.selected))? "selected " : " ") } >
       {buttonText}
    
    {/* { ((SavedInstance.getAllCurrentAnnotations(savedInstances, false, this.props.Context).length > 0) && this.props.commentsOpen ) 
    ? <div className="graft-annotation">{Graft.countAnnotations(childGraft, this.props.Context, false, this.props.Context === "TTFM" 
    ? this.context.getTTFMSavedInstance : this.context.getImagingSavedInstance )}
    </div>
    : null} */}

       </button>
       

        </div>
        
        </>
        ;

        if ((childGraft.type === "PeripheralGraft" || childGraft.type === "AVVein" || childGraft.type === "AVAccessGraft") && !columnContainer )
        {
            columnContainer = [];
            this.rowContainer.push(
                <div  key={"row" + childGraft.id} className="visual-graft-row">
                    {columnContainer}
                </div>);
                if (columnContainer.length > this.indentCountMax)
                {
                    this.indentCountMax = columnContainer.length;
                }
            this.columnContainerAll.push(columnContainer);
            this.columnContainerAllGraftIds.push(childGraft.id as string);   
        }
       if (isTopLevel )
        {
            columnContainer = [];
            if (columnContainer)
                columnContainer.push(itemToAdd);
            //Add a column with the Source button 
            this.rowContainer.push(
                <div key={"row" + childGraft.id} className="visual-graft-row">
                    {columnContainer}
                </div>);
                this.columnContainerAll.push(columnContainer);
                
                columnContainer = [];
                //If it has no sequential but does have a Y then add a ConduitVisualize
                if (yChildren > 0 && sequentialChildren === 0)
                    columnContainer.push(<div className="visual-graft-column is-source"><ConduitVisualize topConduit={parentConduit} bottomConduit={parentConduit}></ConduitVisualize></div>);
              //Add a column as an indent from the source
              if (childGraft.type !== "NewGraft")
                this.rowContainer.push(
                    <div  key={"row2" + childGraft.id} className="visual-graft-row">
                        {columnContainer}
                    </div>);
                    if (columnContainer.length > this.indentCountMax)
                    {
                        this.indentCountMax = columnContainer.length;
                    }
                this.columnContainerAll.push(columnContainer);
                this.columnContainerAllGraftIds.push(childGraft.id as string);   
                
        }
        else if (!childGraft.sequential || isTopLevel )
        {
            columnContainer = [];
            //First Indent based on parent.
            for (let index = 0; index < this.indentCount; index++) {
                //But indentation should only include ConduitVisualize from the direct parent
                if (index >= parentIndent-1)
                {
                    columnContainer.push(<div key={"col"+index} className={"visual-graft-column" + (index===0?" is-source":"")}><ConduitVisualize topConduit={parentConduit} rightConduit={parentConduit}></ConduitVisualize></div>);
                }else
                {
                    columnContainer.push(<div key={"col"+index} className={"visual-graft-column" + (index===0?" is-source":"")}></div>);
                }
                 
                
                    
            }
          
            
            columnContainer.push(itemToAdd);
            
           
            //If it's not sequential add a new row
            this.rowContainer.push(
                <div  key={"row" + childGraft.id} className="visual-graft-row">
                    {columnContainer}
                </div>);
                if (columnContainer.length > this.indentCountMax)
                {
                    this.indentCountMax = columnContainer.length;
                }
            this.columnContainerAll.push(columnContainer);
            this.columnContainerAllGraftIds.push(childGraft.id as string);    
        }
        else
        {
            if (parentIsSource)
            {

                let hasyChild: boolean = (yChildren > 0 ) ;
                //If the parent is the source and this is the first sequential.
                columnContainer.push(<div className="visual-graft-column is-source"><ConduitVisualize topConduit={parentConduit} bottomConduit={(hasyChild ? latestYConduit : null) as string} rightConduit={parentConduit} ></ConduitVisualize> </div>);
           
            }
                
            //If it is sequential add a new column
            if (columnContainer)
            {
                // if (!leftmost)
                // {
                //     if (sequentialChildren === 0)
                //         columnContainer.push(<div className="visual-graft-column is-source"><ConduitVisualize leftConduit={parentConduit} topConduit={null} bottomConduit={null} rightConduit={null} ></ConduitVisualize> </div>);
                // }
                columnContainer.push(itemToAdd);
                if (childGraft.type === "PeripheralGraft")
                {
                    if (sequentialChildren === 0)
                        columnContainer.push(<div className="visual-graft-column"><ConduitVisualize leftConduit={Conduit.LITA} ></ConduitVisualize> 
                         </div>);
                }
                if (childGraft.type === "AVVein")
                {
                    // let conduitChild = parentConduit;
                    // if (childGraft.Targets && childGraft.Targets.length > 0)
                    // {
                    //     conduitChild = childGraft.Targets[0].Conduit;
                    // }

                    // columnContainer.push(<div className="visual-graft-column"><ConduitVisualize leftConduit={parentConduit} topConduit={null} bottomConduit={null} rightConduit={conduitChild} ></ConduitVisualize> </div>);
                    
                }
                if (columnContainer.length > this.indentCountMax)
                {
                    this.indentCountMax = columnContainer.length;
                }
                this.columnContainerAllGraftIds.push(childGraft.id as string);   
            }
        }
        if (childGraft.targets)
        {
        for (let index = 0; index < childGraft.targets.length; index++) {
            
            const element = childGraft.targets[index];
            //If it's sequential then add a new column and a 
            if (element.sequential)
            {
                this.recurseBuildGraft(element, columnContainer,  isTopLevel && index === 0, element.conduit ? element.conduit : parentConduit, 0, yChildren, latestYConduit ? latestYConduit : parentConduit);
            }
            
        }

        for (let index = 0; index < childGraft.targets.length; index++) {
            
            const element = childGraft.targets[index];
            //If it's sequential then add a new column and a 
            if (!element.sequential)
            { 
                this.indentCount++;
                this.recurseBuildGraft(element, [], false, element.conduit, this.indentCount, 0, undefined, false);
            }
            
        }
    }
    }


    render() {
        //TODO: Could workout which one to highlight.
        this.measuredGraftId = "";
         this.indentCount = 0;
         this.indentCountMax = 0;
         this.rowContainer = [];
         this.columnContainerAll = [];
        this.columnContainerAllGraftIds = [];
         let conduitInput = this.props.CurrentItem.conduit;
         if (this.props.CurrentItem.type === "PeripheralGraft")
         {
            conduitInput = (this.props.CurrentItem as VascularGraft).Material as any;
         }

        //  let mainSelected = this.context.GraftMeasured ? false : true;
         //let savedItems = (this.props.Context === "Imaging" ? this.context.getImagingSavedInstance(this.context.GraftMeasured.Id) : this.context.getTTFMSavedInstance(this.context.GraftMeasured.Id));
        //  let savedItems = this.context.getAllSavedInstances(this.context.GraftMeasured.Id) ;
        //  let savedItemsActual = (this.props.Context === "Imaging" ? this.context.getImagingSavedInstance(this.props.CurrentItem.Id) : this.context.getTTFMSavedInstance(this.props.CurrentItem.Id));
        //  if (this.props.CurrentItem.Selected)
        //  {
        //     savedItemsActual = savedItems;
        //  }
        //  let savedItem = savedItems && savedItems.length > 0 ? savedItems[this.context.SelectedSaveIndex] : null;

        this.recurseBuildGraft(this.props.CurrentItem, [], false, conduitInput, 0, 0, undefined, true);
         if (this.props.CurrentItem.type === "AVVein" || this.props.CurrentItem.type === "AVAccessGraft")
            this.manuallyAddAVAccessBottom();
          //Foreach genuine new target added, we need to make sure call parent columns have the same numer.
          for (let index = 0; index < this.columnContainerAll.length; index++) {
            while (this.columnContainerAll[index].length < this.indentCountMax)
                this.columnContainerAll[index].push(<div className="visual-graft-column"></div>);


            if (this.props.showsaves) {
                let graftId = this.columnContainerAllGraftIds[index];
                let measurementsForGraft: PreviewMeasurement[] = [];
                if (this.props.parentProcedure)
                {

                    measurementsForGraft = this.props.parentProcedure.measurements.filter(m => {

                        //Get id of selected segment of graft
                        if (m.intuiGraft)
                        {
                            let GraftFound = Graft.recurseSelected(m.intuiGraft);
                            if (GraftFound.id === graftId)
                            {
                                return true;
                            }
                            
                        }
                        return false;
                    });
                    
                }
                this.columnContainerAll[index].push(<div className="visual-graft-column visual-graft-saves-container">
                   
                 <div className="parkingSpaceContainer"><div className="parkingSpaceHolder" onDragLeave={(event)=>{
                            event.currentTarget.classList.remove("dragover");
                        }} onDragOver={(event)=>{
    
                            event.currentTarget.classList.add("dragover");
    
                        event.preventDefault();  // Allow drop
                        }} onDrop={(event) => {
                            
                            event.currentTarget.classList.remove("dragover");
                         event.preventDefault();
                         const id = event.dataTransfer.getData('text/plain');

                         //Find the measurement using id, clone the this.props.currentItem and then set selected to true on the child graft with id of this.columnContainerAllGraftIds[index] then set intui graft to the cloned graft.
                         if (this.props.parentProcedure && this.props.measurementAllocated)   
                            this.props.measurementAllocated( "", this.props.parentProcedure.id, id, graftId);
                          //  this.props.measurementAllocated(stepIndex, vessel, this.props.parentProcedure.id, id, this.props.parentProcedure.sideUsed);
                             this.forceUpdate();
       
                            
                        }}  ><div className="parkingSpaceDrag">drag here</div><div className="parkedMeasurements">
                            {measurementsForGraft.map((measurementItem) => {
let ThumbIn = <MeasurmentThumbnail key={measurementItem.id} studySelected={this.props.studySelected} dataHelper={this.props.dataHelper} procedureId={this.props.parentProcedure.id} rowData={measurementItem} detailed={false} expanded={()=>{}} />;
 return <div className='allocatedMeasurement'>{ThumbIn}
                                        <button className='allocatedMeasurementDelete' title='Remove from location' onClick={()=>{
                                            if (this.props.parentProcedure && this.props.measurementAllocated)
                                             this.props.measurementAllocated( "", this.props.parentProcedure.id, measurementItem.id, "remove");
                                             this.forceUpdate();
                                        }}>X</button></div>;

                                
                            })
                            }</div></div></div>
            </div>);
            }


                      


                                //  this.props.parentProcedure.measurements.map((measurementItem) =>
                                // {
                                //     if (VascularHelpers.indexOfLocation(stepIndex, vessel, measurementItem.stepLocations) > -1)
                                //     {
                                //         let thumbIn = <MeasurmentThumbnail draggable={true} key={"measurementallocated" +  measurementItem.id} studySelected={this.props.studySelected} dataHelper={this.props.dataHelper} procedureId={this.props.parentProcedure.id} rowData={measurementItem} detailed={false} expanded={()=>{}}> </MeasurmentThumbnail>
                                //             return <div className='allocatedMeasurement'>{thumbIn}
                                //             <button className='allocatedMeasurementDelete' title='Remove from location' onClick={()=>{
                                //                 this.props.measurementAllocated(stepIndex, vessel, this.props.parentProcedure.id, measurementItem.id, this.props.parentProcedure.sideUsed);
                                //                  this.forceUpdate();
                                //             }}>X</button></div>;
                                        
                                //     }else
                                //             return <></>; 
                                // })
                 
           
            
        
        }

        // if (this.props.CurrentItem.Type !== "PreGraft") {
        //     editButton =  <div className="worklist-edit-container"  onClick={this.editGraftClicked}><i className="material-icons worklist-icon-edit">create</i></div>;
        // }
        // commentButton = <div className={"worklist-comment-container "+ (this.props.commentsOpen ? "button-active" : "")  + 
        // (!savedItemsActual || savedItemsActual.length === 0 ? "disabledwl" : "")}
        //   onClick={this.commentGraftClicked}>
        //       <i className={"material-icons worklist-icon-edit " } >comment</i>
        // { (Graft.countAnnotations(this.props.CurrentItem, this.props.Context, true, this.props.Context === "TTFM" ?
        //  this.context.getTTFMSavedInstance 
        //  : this.context.getImagingSavedInstance ) > 0)
        //   ? <div className="graft-annotation">
        //       {Graft.countAnnotations(this.props.CurrentItem, this.props.Context,true, this.props.Context === "TTFM" 
        //       ? this.context.getTTFMSavedInstance 
        //       : this.context.getImagingSavedInstance )}
        //       </div>
        //       : null}
        //       </div>;
        // if (this.props.commentsOpen)
        // {
        //     commentButton = null;
        //     editButton = null;
        // }

        // let previewUrl;
        // let savedCarousel;

    //     if (savedItems && savedItems.length > 0)
    // {
    //     //previewUrl = this.props.savedItems[this.props.savedItems.length-1].pngUrl;
    //     previewUrl = savedItems.reverse().map(((item, index)=>
    //       (
    //         <div className={(index === this.context.SelectedSaveIndex ? "option-container-selected" : "option-container") + " micro " + (item.type === "Flow"  ? "flow" : "imaging")} onClick={()=> {
    //             // this.selectedSaveInCommentSelected(index);
    //             }}>
    //                   <div className="description-container">
    //       <span className="selection-time">{this.context.getCurrentDateTime(item.timeSaved)}</span> 
    //       {/* <span className="selection-graft-name"><WorklistText customGraftText={this.props.customGraftText} CurrentItem={this.props.CurrentGraft} ignoreUnderline={true}></WorklistText></span> */}
    //   </div>
    //         <div className={"thumbnail-container thumbnail-container-transparent " + (item.type === "Flow"  ? "flow" : "imaging")}>
    //         <img src={item.pngUrl}></img>
    //       </div>
    //       {SavedInstance.countAnnotations(item, this.props.Context) > 0 ? <div className="graft-annotation">{SavedInstance.countAnnotations(item, this.props.Context)}</div> : null}
    //       {
    //           item.type === "Flow" 
    //           ?
    //           <div className="thumbnail-values-container">
    //      <MiniTrafficLightTile id={"MeanFlowMiniTile"} key={"MeanFlowMiniTile"}
    //                         value={item.MF}
    //                         title="MF"
    //                         uom="ml/min"
    //                         {...this.context.tileLimits.meanFlow}
    //                         enableColouring={this.props.tileColorOn}
    //                         subTileMode={true} ></MiniTrafficLightTile>
    
    //                 <MiniTrafficLightTile  id={"PulsalityIndexMiniTile"}  key={"PulsalityIndexMiniTile"}
    //                         value={item.PI}
    //                         title="PI"
    //                         uom=""
    //                         maxValue={99}
    //                         {...this.context.tileLimits.pulsalityIndex}
    //                         enableColouring={this.props.tileColorOn} 
    //                         subTileMode={true}></MiniTrafficLightTile>
    //       </div>
    //       : null
    //     }
    //   </div>
    //   )));


       


return ( <>
    <div 
    id={this.props.CurrentItem.id}
        className={"visual-row-container " + (this.props.showSelected && this.props.CurrentItem.selected ? "selected" : "")}>
       <div className={"plain-container " + (this.props.CurrentItem.type === "Target" ? "other-cardiac-target" : "")}> 
       {/* { (SavedInstance.getAllCurrentAnnotations(this.context.getTTFMSavedInstance(this.props.CurrentItem.Id), true, this.props.Context).length > 0) ? <div className="main-graft-annotation graft-annotation">{SavedInstance.getAllCurrentAnnotations(this.context.getTTFMSavedInstance(this.props.CurrentItem.Id), true, this.props.Context).length}</div>: null} */}
        {this.rowContainer}
         <div>{ this.props.showeditbutton ?
                        <button onClick={()=>
                            {
                                if (this.props.parentProcedure && this.props.editGraftClicked)   
                                    this.props.editGraftClicked( "", this.props.parentProcedure.id, this.props.CurrentItem.id as string);
                            }
                        }>Edit</button>:<></>}
                    </div>
        </div>
       
    </div> 
    </>     
    )
  }
}

export default SubwayMap;